module.exports = __webpack_public_path__ + "img/new_slide_4.8ddc307e.jpg";